import { render, staticRenderFns } from "./Onboard.vue?vue&type=template&id=74c45321&scoped=true"
import script from "./Onboard.vue?vue&type=script&lang=js"
export * from "./Onboard.vue?vue&type=script&lang=js"
import style0 from "./Onboard.vue?vue&type=style&index=0&id=74c45321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c45321",
  null
  
)

export default component.exports